// Version 1.9
//
// Use class "modalCentral" to identify a modal to use with this script.
//
// Add the following classes to the modal for options:
//
// withClose: add this if you'd like a close button to be added to the upper
// right hand corner of your modal. This close button should only be used
// against white-ish backgrounds.
//
// dontScroll: add this if you'd like the background NOT to be scrollable when
// the modal is open.
//
// clickOut: add this if you'd like the modal to dismiss when the user clicks
// outside of it when the modal is open.
//
// escOut: add this if you'd like the modal to dismiss when the user presses
// esc when the modal is open.
//
// enterOut: add this if you'd like the modal to dismiss when then user presses
// enter/return when the modal is open.
//
// autoDimiss: add this if you'd like the modal to dismiss automatically after
// 5 seconds.
//
// shrinkFit: add this if you'd like the modal to automatically shrink to fit
// in the window height. It should listen for window resizing also (height only)
//
// Use a call-back function as the second argument (optional) in openModal() or
// closeModal() to execute statements upon closeModal.

var modalCentral = {
    bg: "<div id='modalCentralBg'></div>",
    closeBtn: "<button id='modalCentralCloseBtn'></button>",
    init: function() {
        // $(".modalCentral").hide(); // This function is now handled by display: none in modal-central.scss
        $("body").append(modalCentral.bg);
        // $("#modalCentralBg").hide(); // This function is now handled by display: none in modal-central.scss
    },
    placeModal: function(modalID) {
        if ($("#" + modalID).hasClass("shrinkFit")) {
            modalCentral.fitToWindow(modalID);
        }
        var modalTop = ($(window).height() - $("#" + modalID).outerHeight()) / 2,
            modalLeft = ($(window).width() - $("#" + modalID).outerWidth()) / 2;
        $("#" + modalID).css({top: modalTop, left: modalLeft});
        if ($("#" + modalID).hasClass("withClose")) {
            $("#modalCentralCloseBtn").css({
                top: modalTop + 5,
                left: modalLeft + $("#" + modalID).outerWidth() - 42
            });
        }
    },
    openModal: function(modalID, closeFunct) {
        var closeFn = closeFunct != undefined ? closeFunct : function() {};
        if ($("#" + modalID).hasClass("withClose")) {
            $("body").append(modalCentral.closeBtn);
            $("#modalCentralCloseBtn").on("click.modalCentralCloseBtn", function() {
                modalCentral.closeModal(modalID, closeFn);
                return false;
            });
        }
        $("#" + modalID).show();
        $("#modalCentralBg").show();
        $(window).on("resize.modalCentralWindowResize", function() { modalCentral.placeModal(modalID); });
        modalCentral.placeModal(modalID);
        if ($("#" + modalID).hasClass("dontScroll")) { $("body").addClass("modalCentralDontScroll"); }
        if ($("#" + modalID).hasClass("clickOut")) {
            $("#modalCentralBg").on("click.modalCentralBgClick", function() {
                modalCentral.closeModal(modalID, closeFn);
                return false;
            });
        }
        if ($("#" + modalID).hasClass("escOut")) {
            $(window).on("keydown.modalCentralEsc", function(evt) {
                var key = evt.which;
                if (key == 27) {
                    modalCentral.closeModal(modalID, closeFn);
                    return false;
                }
            });
        }
        if ($("#" + modalID).hasClass("enterOut")) {
            $(window).on("keydown.modalCentralEnter", function(evt) {
                var key = evt.which;
                if (key == 13) {
                    modalCentral.closeModal(modalID, closeFn);
                    return false;
                }
            });
        }
        if ($("#" + modalID).hasClass("autoDismiss")) {
            setTimeout(function() {
                modalCentral.closeModal(modalID, closeFn);
            },5000);
        }
    },
    closeModal: function(modalID, closeFn) {
        $("#" + modalID).hide();
        $("#modalCentralCloseBtn").remove();
        $("body").removeClass("modalCentralDontScroll");
        $("#modalCentralBg")
            .hide()
            .off("click.modalCentralCloseBtn")
            .off("click.modalCentralBgClick");
        $(window)
            .off("resize.modalCentralWindowResize")
            .off("keydown.modalCentralEsc")
            .off("keydown.modalCentralEnter");
        if (closeFn != undefined) closeFn();
    },
    fitToWindow: function(modalID){
        var w = window, d = document, e = d.documentElement, g = d.getElementsByTagName('body')[0], y = w.innerHeight || e.clientHeight || g.clientHeight;
        if ($("#" + modalID)[0].scrollHeight > y) {
            $("#" + modalID).height(y - 150);
        } else if ($("#" + modalID)[0].scrollHeight < y) {
            $("#" + modalID).height('auto');
        }
    }
}
modalCentral.init();
